import { useRoute } from 'vue-router'

export function usePageReloaded(): boolean
{
    return window.performance
        .getEntriesByType('navigation')
        .map((nav) => (nav as PerformanceNavigationTiming).type)
        .includes('reload');
}

export function useOrganizationUnitId(): string
{
    return useRoute().params.tid as string;
}

export function useWorkspaceId(): number
{
    return parseInt(useRoute().params.wid as string);
}

export function useProjectId(): number
{
    return parseInt(useRoute().params.pid as string);
}

export function useId(): string
{
    return useRoute().params.id as string;
}

export function useIdsPath(): { tid: number; wid: number; pid: number; id: string }
{
    const params = useRoute().params as any;

    return {
        tid: parseInt(params.tid),
        wid: parseInt(params.wid),
        pid: parseInt(params.pid),
        id: params.id
    };
}
